import React, { useState } from 'react';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import StarRatingComponent from '../StarRatingComponent';

import { Avatar, Button, Card, Snackbar, Typography } from '@mui/joy';
import { Report } from '@mui/icons-material';

//@ts-ignore
import '../../styles/appinfooverview.scss';
import { cardStyles } from '../../styles/cardStyles';

const networking = require('../../Networking/API');
const helper = require('../../Helpers/helpers');

function AppRatingComponent({ app, type }: any) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [rating, setRating] = useState(null) as any;

    if (!rating) {
        getData();
    }

    function getData() {
        networking.ratingsFor(app.id, type).then((rating: any) => {
            setRating(rating);
            setLoading(false);
        }).catch((error: Error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    return (
        <>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            <Card
                variant='outlined'
                sx={{
                    ...cardStyles.base
                }}>
                {loading ?
                    <LoadingSpinnerComponent />
                    :
                    <div>
                        <div className='row'>
                            <div className='col-md-auto my-auto iron legend bold'>
                                <Avatar>
                                    {helper.iconFor(type === 'apple' || type === 'google' ? type + 'store' : type, 24)}
                                </Avatar>
                            </div>
                            <div className='col-md-auto my-auto'>
                                {rating &&
                                    <>
                                        <Typography
                                            level='title-md'>
                                            {rating.userRatingCount}
                                            <span>
                                                <Typography
                                                    level='body-xs'>
                                                    {' ratings'}
                                                </Typography>
                                            </span>
                                        </Typography>
                                        <Typography
                                            level='body-xs'>
                                            {type === 'apple' ? app.apple_version : app.google_version}
                                        </Typography>
                                    </>
                                }
                            </div>
                            <div className='col-md-auto my-auto'>
                                {rating &&
                                    <div className='d-flex flex-column align-items-left'>
                                        <StarRatingComponent
                                            rating={rating.averageUserRating}
                                            size={'small'}
                                        />
                                        <Typography
                                            level='body-xs'>
                                            {(Math.round(rating.averageUserRating * 100) / 100).toFixed(1) + ' Stars'}
                                        </Typography>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </Card>
        </>
    )
}

export default AppRatingComponent;